import { FORM_ID } from "../../../../../constants/Forms";
import ReviewSignSectionHeader from "./ReviewSignSectionHeader";

function ReviewCCB(props) {
  const toggleForm = () => {
    props.toggleForm(FORM_ID.CCB);
  };
  return (
    <div id="rew-ccb">
      <ReviewSignSectionHeader
        toggleForm={toggleForm}
        id={"ccb"}
        headerText="Character, Credit, and Bonding"
      ></ReviewSignSectionHeader>

      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12" id="ccb-ques">
          <h5>
            Are you now or have you in the past been directly or indirectly
            involved in a lawsuit since you have been in the business of
            insurance?
          </h5>
        </div>
        <div id="lawsuit" className="col-lg-6 col-md-6 col-sm-12 data">
          {props.characterCreditBonding.invlawsuit ? "Yes" : "No"}
        </div>
      </div>

      {props.characterCreditBonding.invlawsuit && (
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12" id="qstn-lwst">
            <h5>
              Please explain your involvement in a lawsuit relative to insurance
              practice.
            </h5>
          </div>
          <div id="lawsuit_text" className="col-lg-6 col-md-6 col-sm-12 data">
            <>{props.characterCreditBonding.invlawsuitdesc}</>
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12" id="questn-cnvtd">
          <h5>
            Have you ever been convicted of any crime (felony or misdemeanor)?
          </h5>
        </div>
        <div id="crime" className="col-lg-6 col-md-6 col-sm-12 data">
          {props.characterCreditBonding.convictcrime ? "Yes" : "No"}
        </div>
      </div>

      {props.characterCreditBonding.convictcrime && (
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12" id="crime">
            <h5>
              Please explain the crime (felony or misdemeanor) of which you have
              been convicted.
            </h5>
          </div>
          <div id="crime_text" className="col-lg-6 col-md-6 col-sm-12 data">
            {props.characterCreditBonding.convictcrimedesc}
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12" id="license">
          <h5 id="lcnse">
            Have you ever had a professional license suspended, revoked,
            cancelled, or had your employment or contract ‘terminated for
            cause’?
          </h5>
        </div>
        <div id="suspended" className="col-lg-6 col-md-6 col-sm-12 data">
          {props.characterCreditBonding.licsuspend ? "Yes" : "No"}
        </div>
      </div>

      {props.characterCreditBonding.licsuspend && (
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12" id="lcnse-suspended">
            <h5>
              Please explain why your professional license was suspended,
              revoked, cancelled, or why your employment or contract was
              ‘terminated for cause’.
            </h5>
          </div>
          <div id="suspended_text" className="col-lg-6 col-md-6 col-sm-12 data">
            {props.characterCreditBonding.licsuspenddesc}
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12" id="bankruptcy">
          <h5 id="bnkrpcy">
            Have you ever failed in business, declared bankruptcy, compromised
            with creditors, or had any liens or judgments against you?
          </h5>
        </div>
        <div id="bankruptcy" className="col-lg-6 col-md-6 col-sm-12 data">
          {props.characterCreditBonding.failedbusiness ? "Yes" : "No"}
        </div>
      </div>

      {props.characterCreditBonding.failedbusiness && (
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12" id="bsiness">
            <h5>
              Please explain if you have ever failed in business, declared
              bankruptcy, compromised with creditors, or had any liens or
              judgments against you.
            </h5>
          </div>
          <div
            id="bankruptcy_text"
            className="col-lg-6 col-md-6 col-sm-12 data"
          >
            {props.characterCreditBonding.failedbusinessdesc}
          </div>
        </div>
      )}
    </div>
  );
}
export default ReviewCCB;
